export const BREAKPOINTS = {
  desktop: '(max-width: 1920px)',
  laptop: '(max-width: 1280px)',
  tablet: '(max-width: 768px)',
  phone: '(max-width: 428px)',
};
